/* eslint-disable react-native/no-inline-styles */
import { PLANE_DEFAULT_Z } from '@Components/BigBrowse/BigBrowseConfig';
import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import type {
  PlaneSize,
  Position2D,
} from '@Components/BigBrowse/Model/ModelTypes';
import { Assets } from '@Utils/AssetsStore';
import { Html } from '@react-three/drei';
import { observer } from 'mobx-react-lite';

type Props = CardTextProps & {
  position?: Position2D;
} & { size?: PlaneSize } & { style?: any };

export const HtmlText = observer(function HtmlText({
  position = { x: 0, y: 0 },
  size = { width: 0, height: 0 },
  fontAsset = Assets.Font_Gilroy_Medium,
  zPosition,
  style = {},
  ...props
}: Props) {
  return (
    <Html
      position={[position.x, position.y, zPosition ?? PLANE_DEFAULT_Z]}
      style={{
        pointerEvents: 'none',
        width: size.width,
        height: size.height,
        cursor: 'default',
      }}
      center
      zIndexRange={[0, 0]} // needed so it does not render behind parent elements and containers
    >
      <div
        style={{
          fontFamily: fontAsset,
          letterSpacing: props.letterSpacing,
          ...props,
          ...style,
        }}
      >
        {props.text}
      </div>
    </Html>
  );
});
